/**
 * get promotion name using page handle, section title, destination url, sectionName only for FlexGrid block modal which does not have title and url
 * @param {string} handle
 * @param {string} name
 */
export const getPromoName = (handle, name) => `${handle} -> ${name}`;

/**
 * tracking landing page promotion click and send to GTM
 * @param {Object} promotion
 */
export const trackPromotionClick = (promotion) => {
  window.dataLayer.push({
    event: 'promotionClick',
    ecommerce: {
      promoClick: {
        promotions: [promotion]
      }
    }
  });
};
